import css from './index.module.scss';
import createEFPic from '@/utils/useEFPic';
import { useGlobal } from '@/utils/useGlobal';

const { EFPic } = createEFPic('/media/deltapro/');

export default function Section18() {
    const { useLang, useRouter } = useGlobal();
    const { t } = useLang('delta_pro_new');
    const { locale } = useRouter();

    const sceneList = [
        {
            img: ['scene1.webp', 'scene1.png'],
            title: t('section18_scene1_title'),
            desc: t('section18_scene1_desc'),
        },
        {
            img: ['scene2.webp', 'scene2.png'],
            title: t('section18_scene2_title'),
            desc: t('section18_scene2_desc'),
        },
        {
            img: ['scene3.webp', 'scene3.png'],
            title: t('section18_scene3_title'),
            desc: t('section18_scene3_desc'),
        },
    ];

    if (locale === 'us') {
        sceneList.push({
            img: ['scene4.webp', 'scene4.png'],
            title: t('section18_scene4_title'),
            desc: t('section18_scene4_desc'),
        });
    }

    return (
        <div
            className={`${css.section18} GtmModuleData-section`}
            data-section-id={css.section18}
            data-section-title={t.rich('section18_title', {
                line1: (child: string) => {
                    child;
                },
            })}
        >
            <div className="wrapper">
                <div className="title">
                    {t.rich('section18_title', {
                        line1: (child: string) => <span className="color-blue">{child}</span>,
                    })}
                </div>
                <div className="desc">{t('section18_desc')}</div>
                <div className="scene-list">
                    {sceneList.map((item, index) => (
                        <div className="scene" key={index}>
                            <div className="scene-img">
                                <EFPic name={item.img} alt={item.title} aria-label={item.title} />
                            </div>
                            <div className="scene-title">{item.title}</div>
                            <div className="scene-desc">{item.desc}</div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}
